import { z } from 'zod'
import { NotificationType } from '../../enums'

export const updateTelegramPreferencesSchema = z.object({
  preferences: z.array(
    z.object({
      notificationType: z.nativeEnum(NotificationType),
      enabled: z.boolean(),
    })
  ),
})

export type UpdateTelegramPreferencesDto = z.infer<typeof updateTelegramPreferencesSchema>
